
  

import axios from "axios";

const serverApi = axios.create({
    baseURL: 'https://q10gsl5s9d.execute-api.us-east-1.amazonaws.com',
    

});

export const getStudents = async () => {
    return serverApi.get('/public/students').then(res => res.data);
};
export const createStudent = async (body) => {
    return serverApi.post('/public/students', body).then((res) => res.data);
};
export const updateStudent = async (id, body) => {
    return serverApi.patch(`/public/students/${id}`, body).then((res) => res.data);
};
export const replaceStudent = async (id, body) => {
    return serverApi.put(`/public/students/${id}`, body).then((res) => res.data);
};
export const deleteStudents = async (id) => {
     return serverApi.delete(`/public/students/${id}`).then((res) => res.data);
};

deleteStudents("69b982c8acc4b3616f1ee3ef")
  .then(data => console.log(data))
  .catch(err => console.error(err));


  getStudents()
  .then(data => console.log(data))
  .catch(err => console.error(err));